import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-flat5',
  templateUrl: './flat5.component.html',
  styleUrls: ['./flat5.component.scss']
})
export class Flat5Component implements OnInit {

  phFloorSelected: boolean;
  floorsArray: any[];
  selectedIndexFloor: number = 1;
  numberOfFloors: number = 0;

  constructor(public dialogRef: MatDialogRef<Flat5Component>,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    if (data) {
      this.numberOfFloors = data['numberOfFloors'];
      this.floorsArray = this.createRange(this.numberOfFloors, true);
    }
  }

  ngOnInit() {
  }

  createRange(limit: number, reverse: boolean = false) {
    var items: number[] = [];
    for (var i = 1; i <= limit; i++) {
      items.push(i);
    }
    return reverse ? items.sort((a, b) => b - a) : items;
  }

  changeFloor(event: any) {
    var element = event.target;
    var currentFloor = parseInt(element.getAttribute('id'));
    this.selectedIndexFloor = currentFloor;
    this.phFloorSelected = true;
  }

}
